
























import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { DeviceType, AppModule } from "@/store/modules/app";
import { SettingsModule } from "@/store/modules/settings";
import { AppMain, Navbar, Settings, Sidebar, TagsView } from "./components";
import RightPanel from "@/components/RightPanel/index.vue";
import ResizeMixin from "./mixin/resize";

@Component({
  name: "Layout",
  components: {
    AppMain,
    Navbar,
    Sidebar,
    Settings,
    TagsView,
    RightPanel,
  },
})
export default class extends mixins(ResizeMixin) {
  private isshow: any = true;
  mounted() {
    const param: any = window.sessionStorage.getItem("islogin");

    if (JSON.parse(param).islogin == true) {
      this.isshow = true;
    } else {
      this.isshow = false;
    }
    console.log(this.isshow);
  }
  get classObj() {
    return {
      hideSidebar: !this.sidebar.opened,
      openSidebar: this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation,
      mobile: this.device === DeviceType.Mobile,
    };
  }

  private handleClickOutside() {
    AppModule.CloseSideBar(false);
  }
  get showTagsView() {
    return SettingsModule.showTagsView;
  }
  get showSettings() {
    return SettingsModule.showSettings;
  }
  get fixedHeader() {
    return SettingsModule.fixedHeader;
  }
}
